// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Общие стили */
.navigatorСode-subtitle {
  display: grid;
  font-size: 2vw;
  place-self: center;
}
.navigatorСode-buttonCheck {
  display: flex;
  gap: 0.5vw;
  padding: 0.4vw 0.75vw;
  justify-content: space-evenly;
  border-radius: 0.9vw;
  width: max-content;
  cursor: pointer;
  color: white;
  place-self: center;
  font-size: 1.8vw;
  white-space: nowrap;
  background-color: #1a6a7c;
}
.navigatorСode-logoRun {
  height: 2.1vw;
  place-self: center;
}

.navigatorСode-Board {
  display: flex;
  gap: 4vw;
}
/* игровое поле */

.navigatorСode-board-game {
  display: flex;
  align-items: center;
  flex: 1 1;
  flex-direction: column;
  justify-content: space-between;
  margin-right: 2.6vw;
  gap: 1vw;
}

/* поле с кнопкой и полем для проверки отгадки */

.navigatorСode-button-input-board {
  -webkit-user-select: none;
          user-select: none; 
  display: grid;
  gap: 0.4vw;
  grid-template-columns: auto auto 8vw;
}

.navigatorСode-input {
  padding-left: 0.8vw;
  font-size: 2vw;
  height: 3vw;
  background-color: #ffffff;
  outline: none;
  text-transform: uppercase;
  border: 0.1vw #1a6a7c solid;
  border-radius: 0.6vw;
}
/* ПОБЕДА */
.navigatorСode-card-container {
  display: grid;
  margin-top: auto;
  margin-bottom: auto;
  perspective: 1000px;
}

.navigatorСode-card-flipped {
  transform: rotateY(180deg);
}

.navigatorСode-card {
  position: relative;
  display: grid;
  transform-style: preserve-3d;
  transition: transform 2s ease;
}

.navigatorСode-card-face {
  grid-area: 1 / 1;

  display: flex;
  justify-content: center;
  align-items: center;

  backface-visibility: hidden;
}

.navigatorСode-card-front {
  background: white;
}

.navigatorСode-card-back {
  position: absolute;
  inset: 0;

  background: white;
  transform: rotateY(180deg);
}
.navigatorСode-win-square {
  display: flex;
  justify-content: center;
  align-items: center;

  background: white;
}
.navigatorСode-wrong {
  background: #ffc0c0;
}

.navigatorСode-correct {
  background: #e6ffe6;
}
.navigatorСode-win-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
/* починить рамку */
.canvas-test{
 box-shadow: 0 0.2vw 0.4vw rgba(0, 0, 0, 0.12), 0 0.3vw 1vw rgba(0, 0, 0, 0.08);
}`, "",{"version":3,"sources":["webpack://./src/TaskWindows/NavigatorСode/styles/Navigator%D0%A1odeBoard.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;EACE,aAAa;EACb,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,UAAU;EACV,qBAAqB;EACrB,6BAA6B;EAC7B,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;AACA,iBAAiB;;AAEjB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAO;EACP,sBAAsB;EACtB,8BAA8B;EAC9B,mBAAmB;EACnB,QAAQ;AACV;;AAEA,gDAAgD;;AAEhD;EACE,yBAAiB;UAAjB,iBAAiB;EACjB,aAAa;EACb,UAAU;EACV,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,WAAW;EACX,yBAAyB;EACzB,aAAa;EACb,yBAAyB;EACzB,2BAA2B;EAC3B,oBAAoB;AACtB;AACA,WAAW;AACX;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;;EAEhB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;;EAEnB,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;;EAER,iBAAiB;EACjB,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;;EAEnB,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;AACA,mBAAmB;AACnB;CACC,8EAA8E;AAC/E","sourcesContent":["/* Общие стили */\n.navigatorСode-subtitle {\n  display: grid;\n  font-size: 2vw;\n  place-self: center;\n}\n.navigatorСode-buttonCheck {\n  display: flex;\n  gap: 0.5vw;\n  padding: 0.4vw 0.75vw;\n  justify-content: space-evenly;\n  border-radius: 0.9vw;\n  width: max-content;\n  cursor: pointer;\n  color: white;\n  place-self: center;\n  font-size: 1.8vw;\n  white-space: nowrap;\n  background-color: #1a6a7c;\n}\n.navigatorСode-logoRun {\n  height: 2.1vw;\n  place-self: center;\n}\n\n.navigatorСode-Board {\n  display: flex;\n  gap: 4vw;\n}\n/* игровое поле */\n\n.navigatorСode-board-game {\n  display: flex;\n  align-items: center;\n  flex: 1;\n  flex-direction: column;\n  justify-content: space-between;\n  margin-right: 2.6vw;\n  gap: 1vw;\n}\n\n/* поле с кнопкой и полем для проверки отгадки */\n\n.navigatorСode-button-input-board {\n  user-select: none; \n  display: grid;\n  gap: 0.4vw;\n  grid-template-columns: auto auto 8vw;\n}\n\n.navigatorСode-input {\n  padding-left: 0.8vw;\n  font-size: 2vw;\n  height: 3vw;\n  background-color: #ffffff;\n  outline: none;\n  text-transform: uppercase;\n  border: 0.1vw #1a6a7c solid;\n  border-radius: 0.6vw;\n}\n/* ПОБЕДА */\n.navigatorСode-card-container {\n  display: grid;\n  margin-top: auto;\n  margin-bottom: auto;\n  perspective: 1000px;\n}\n\n.navigatorСode-card-flipped {\n  transform: rotateY(180deg);\n}\n\n.navigatorСode-card {\n  position: relative;\n  display: grid;\n  transform-style: preserve-3d;\n  transition: transform 2s ease;\n}\n\n.navigatorСode-card-face {\n  grid-area: 1 / 1;\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  backface-visibility: hidden;\n}\n\n.navigatorСode-card-front {\n  background: white;\n}\n\n.navigatorСode-card-back {\n  position: absolute;\n  inset: 0;\n\n  background: white;\n  transform: rotateY(180deg);\n}\n.navigatorСode-win-square {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  background: white;\n}\n.navigatorСode-wrong {\n  background: #ffc0c0;\n}\n\n.navigatorСode-correct {\n  background: #e6ffe6;\n}\n.navigatorСode-win-image {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n/* починить рамку */\n.canvas-test{\n box-shadow: 0 0.2vw 0.4vw rgba(0, 0, 0, 0.12), 0 0.3vw 1vw rgba(0, 0, 0, 0.08);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
